export default __webpack_public_path__ + "static/media/image.473d35de.png";